import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { primeFeedData } from '../../utils/feedPrefetch';
import Footer from '../../components/Footer';
import { API_BASE } from '../../config';

const SHOW_AUTH_HEADER = true;
const SHOW_AUTH_FOOTER = true;

function Log_in() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    setError('');

    try {
      const response = await fetch(`${API_BASE}/api/Account/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        const errorText = await response.text();
        if (response.status === 400 && errorText.includes('Email не подтверждён')) {
          throw new Error('Ваш email не подтвержден. Пожалуйста, проверьте почту.');
        } else if (response.status === 401) {
          throw new Error('Неверный email или пароль');
        } else {
          throw new Error(errorText || 'Ошибка входа');
        }
      }

      const data = await response.json();
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data));

      primeFeedData();
      
      if (!data.isOnboardingCompleted) {
        navigate('/new-questionnaire', { replace: true });
      } else {
        navigate('/profile', { replace: true });
      }
    } catch (err) {
      console.error('Login error:', err);
      if (err.message === 'Failed to fetch') {
        setError('Ошибка соединения с сервером. Убедитесь, что API запущен.');
      } else {
        setError(err.message);
      }
    }
  };

  return (
    <div className={`log_in min-h-screen flex flex-col${!SHOW_AUTH_HEADER && !SHOW_AUTH_FOOTER ? ' log_in--body-only' : ''}`}>
      <main className="log_in__main">
        <h1 className="log_in__title">Вход</h1>

        <div className="log_in__form-wrap">
          <form onSubmit={handleLogin} className="log_in__form" noValidate>
            <div>
              <label htmlFor="email" className="log_in__label">Email</label>
              <input
                id="email"
                name="email"
                type="email"
                required
                autoComplete="email"
                placeholder="admin@gmail.com"
                value={formData.email}
                onChange={handleChange}
                className="log_in__input"
              />
            </div>

            <div>
              <div className="log_in__password-head">
                <label htmlFor="password" className="log_in__label">Пароль</label>
                <a href="#" className="log_in__link">Забыли пароль?</a>
              </div>

              <div className="log_in__field">
                <input
                  id="password"
                  name="password"
                  type={showPassword ? 'text' : 'password'}
                  required
                  autoComplete="current-password"
                  placeholder="введите свой пароль"
                  value={formData.password}
                  onChange={handleChange}
                  className="log_in__input log_in__input--password"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="log_in__toggle-pass"
                  aria-label={showPassword ? 'Скрыть пароль' : 'Показать пароль'}
                >
                  {showPassword ? (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  ) : (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24M1 1l22 22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  )}
                </button>
              </div>
            </div>

            {error && <p className="log_in__error">{error}</p>}

            <div className="log_in__submit-wrap">
              <button type="submit" className="log_in__submit">Войти</button>
            </div>
          </form>

          <p className="log_in__register">
            Ещё нет аккаунта? <Link to="/registrations">Зарегистрироваться</Link>
          </p>
        </div>
      </main>

      {SHOW_AUTH_FOOTER && <Footer variant="auth" />}
    </div>
  );
}

export default Log_in;
